import { memo } from "react";
import useHighRiskActions from "features/onboarding/useHighRiskActions";
import { ApplicationsTableResource } from "./common";

const HighRisk = () => {
    const {
        getApplications,
        downloadCsv,
    } = useHighRiskActions();

    return (
        <ApplicationsTableResource
            fetchTableData={getApplications}
            downloadCsv={downloadCsv}
            resourceName='High Risk'
        />
    );
};

export default memo(HighRisk);
